/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ReportWrapper_surveys = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportWrapper_surveys",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ReportHeader_surveys",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AdminReportGrid_surveys",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserReportGrid_surveys",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CreateWidgetDialog_surveys",
      "args": null
    }
  ],
  "type": "SurveyConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/__generated__/ReportWrapper_surveys.graphql.js